export default "__VITE_ASSET__B_Obn9cs__"